import styles from './NotificationBell.module.css';
import ONotificationsList from './ONotificationsList';
import { formatDistanceToNow } from 'date-fns';
import { enUS, srLatn } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

const getDateLocale = (language) =>
  String(language || '')
    .toUpperCase()
    .startsWith('EN')
    ? enUS
    : srLatn;

const formatNotificationTime = (value, language) => {
  if (!value) return '';

  try {
    const locale = getDateLocale(language);
    if (value?.seconds) {
      return formatDistanceToNow(new Date(value.seconds * 1000), { locale });
    }

    return formatDistanceToNow(new Date(value), { locale });
  } catch {
    return '';
  }
};

const NotificationBell = ({
  unreadNotifications,
  userNotifications = [],
  onRead,
  onOpenDetails,
  onReadAll,
  unreadOnly = false,
  onUnreadFilterChange,
  onOpen,
}) => {
  const { i18n } = useTranslation();

  const formattedNotifications = userNotifications.map((item) => ({
    ...item,
    time: formatNotificationTime(item.time, i18n.language),
  }));

  return (
    <div className={styles.container} style={{ cursor: 'pointer' }}>
      <ONotificationsList
        align="end"
        options={formattedNotifications}
        onRead={onRead}
        onOpenDetails={onOpenDetails}
        onReadAll={onReadAll}
        unreadOnly={unreadOnly}
        onUnreadFilterChange={onUnreadFilterChange}
        onOpen={onOpen}
      >
        <div
          className={`${styles.bell} ${
            unreadNotifications > 0 ? styles['bell-animation'] : ''
          }`}
        >
          {unreadNotifications > 0 && (
            <span className={styles.number}>
              {unreadNotifications > 99 ? '99+' : unreadNotifications}
            </span>
          )}

          <div
            className={`${styles['bell-border']} ${
              unreadNotifications > 0 ? styles['bell-border-animation'] : ''
            }`}
          />

          <i
            className={`fas fa-bell ${styles['btn-bell']} ${
              unreadNotifications > 0 ? styles['btn-bell-animation'] : ''
            }`}
          />
        </div>
      </ONotificationsList>
    </div>
  );
};

export default NotificationBell;
